import React from "react";

export const GroupIcon = ({ nameOfClass }) => (
    <svg className={`icon ${nameOfClass ? nameOfClass: ""}`} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.25 17.5H2.5V8.75H5V6.25H2.5C1.12109 6.25 0 7.37109 0 8.75V17.5C0 18.8789 1.12109 20 2.5 20H11.25C12.6289 20 13.75 18.8789 13.75 17.5V15H11.25V17.5ZM8.75 13.75H17.5C18.8789 13.75 20 12.6289 20 11.25V2.5C20 1.12109 18.8789 0 17.5 0H8.75C7.37109 0 6.25 1.12109 6.25 2.5V11.25C6.25 12.6289 7.37109 13.75 8.75 13.75Z" />
    </svg>
);
